import { getArtifactCardFormatter } from './artifact-card/registry';
import { jsx as _jsx } from "react/jsx-runtime";
const ArtifactCardSectionFormatter = ({
  section,
  callbacks
}) => {
  var _section$payload;
  const Formatter = getArtifactCardFormatter((_section$payload = section.payload) === null || _section$payload === void 0 ? void 0 : _section$payload.__typename);
  return /*#__PURE__*/_jsx(Formatter, {
    section: section,
    callbacks: callbacks
  });
};
export default ArtifactCardSectionFormatter;